import { render, staticRenderFns } from "./douyinPeople.vue?vue&type=template&id=2f291550"
import script from "./douyinPeople.vue?vue&type=script&lang=js"
export * from "./douyinPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports